
const chatMessagesData = [
    {
        align: '',
        name: 'CHATBOT',
        message: 'Chào mừng bạn đã đến với CHAT BOT VỀ CỔNG DỊCH VỤ CÔNG!',
        time: ""
    },
    {
        align: '',
        name: 'CHATBOT',
        message: 'BẠN ĐANG THẮC MẮC VỀ VẤN ĐỀ GÌ CẦN CHÚNG TÔI HỖ TRỢ',
        time: ''
    },
];

const baseMessage =  [
    {
        align: '',
        name: 'CHATBOT',
        message: 'Chào mừng bạn đã đến với CHAT BOT VỀ CỔNG DỊCH VỤ CÔNG!',
        time: ""
    },
    {
        align: '',
        name: 'CHATBOT',
        message: 'BẠN ĐANG THẮC MẮC VỀ VẤN ĐỀ GÌ CẦN CHÚNG TÔI HỖ TRỢ',
        time: ''
    },
];

export { chatMessagesData  , baseMessage };
